module.exports = __webpack_public_path__ + "img/warehouse.adee2ad2.svg";